import useSWR from "swr";
import { SWRApiError, swrConfigOptions, useFetcher } from "./swr";
import { RawRecipe } from "@/types/recipe";

export const useRecipes = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawRecipe[], SWRApiError>(
    { url: "/recipes" },
    fetcher,
    swrConfigOptions,
  );

  return { data, ...rest };
};
